import { useState, useEffect } from 'react';
import MyContext from './Context';
import {collection, deleteDoc,getDocs, doc, onSnapshot, orderBy, query } from 'firebase/firestore';
import { fireDB } from '../firebase/FirebaseConfig';
import toast from "react-hot-toast";

function State({ children }) {

    const [loading, setLoading] = useState(false);
    


  const [getAllResort, setGetAllResort] = useState([]);

  const getAllResortFunction = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(fireDB, "resorts"));
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setGetAllResort(data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllResortFunction();
  }, []);

  
    // Order State 
    const [getAllOrder, setGetAllOrder] = useState([]);


    /**========================================================================
     *========================================================================**/

    const getAllOrderFunction = async () => {
        setLoading(true);
        try {
            const q = query(
                collection(fireDB, "order"),
                orderBy('time')
            );
            const data = onSnapshot(q, (QuerySnapshot) => {
                let orderArray = [];
                QuerySnapshot.forEach((doc) => {
                    orderArray.push({ ...doc.data(), id: doc.id });
                });
                setGetAllOrder(orderArray);
                setLoading(false);
            });
            return () => data;
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

        // Delete oder Function
        const orderDelete = async (id) => {
            setLoading(true)
            try {
                await deleteDoc(doc(fireDB, 'order', id))
                toast.success('Order Deleted successfully')
                getAllOrderFunction();
                setLoading(false)
            } catch (error) {
                console.log(error)
                setLoading(false)
            }
        }

            // user State 
    const [getAllUser, setGetAllUser] = useState([]);

        /**========================================================================
     *                           GET All User Function
     *========================================================================**/

    const getAllUserFunction = async () => {
        setLoading(true);
        try {
            const q = query(
                collection(fireDB, "user"),
                orderBy('time')
            );
            const data = onSnapshot(q, (QuerySnapshot) => {
                let userArray = [];
                QuerySnapshot.forEach((doc) => {
                    userArray.push({ ...doc.data(), id: doc.id });
                });
                setGetAllUser(userArray);
                setLoading(false);
            });
            return () => data;
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }


    // *                     GET All Product Raise fucntion
    // *========================================================================**

    // const [getAllRaiseRequests, setRequests] = useState([]);

    // const getAllRequestsfunction = async () => {
    //     setLoading(true);

    //     try {
    //         const querySnapshot = await getDocs(collection(fireDB, "productRaise"));
    //         const requestsData = [];
    //         querySnapshot.forEach((doc) => {
    //             requestsData.push({ id: doc.id, ...doc.data() });
    //         });
    //         setRequests(requestsData);
            
    //     } catch (error) {
    //         console.error("Error fetching requests:", error);
    //         toast.error("Failed to fetch requests");
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    useEffect(() => {
        // getAllRequestsfunction();
    
        getAllOrderFunction();
        getAllUserFunction();
    }, []);


    return (
      <MyContext.Provider
        value={{
          loading,
          setLoading,
          
          getAllResort,
          getAllResortFunction,

        //   getAllRequestsfunction,
        //   getAllRaiseRequests,

          getAllOrder,
          orderDelete,
          getAllUser,
        }}
      >
        {children}
      </MyContext.Provider>
    );
}

export default State